import React from 'react';
import { AppProvider, useApp } from './context/AppContext';
import Header from './components/Header';
import AuthModal from './components/AuthModal';
import SearchView from './components/SearchView';
import ProfileView from './components/ProfileView';
import BookingView from './components/BookingView';
import PaymentView from './components/PaymentView';
import ConfirmationView from './components/ConfirmationView';

function AppContent() {
  const { view } = useApp();

  return (
    <div className="min-h-screen bg-slate-50">
      {view !== 'confirmation' && <Header />}
      <AuthModal />
      {view === 'search' && <SearchView />}
      {view === 'profile' && <ProfileView />}
      {view === 'booking' && <BookingView />}
      {view === 'payment' && <PaymentView />}
      {view === 'confirmation' && <ConfirmationView />}
    </div>
  );
}

function CareConnectApp() {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
}

export default CareConnectApp;
